import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaShoppingCart } from 'react-icons/fa'; // Sumamos el ícono del carrito
import { useCart } from '../context/CartContext'; // Importamos el contexto
import CarritoSidebar from './CarritoSidebar'; // Importamos el modal
import './Navbar.css';

import logoPascolo from '../assets/pascolo-verde.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const { cart, isCartOpen, setIsCartOpen } = useCart();
  const totalItems = cart.reduce((acc, item) => acc + item.cantidad, 0);
  // Contacto wsp
  const numeroWhatsapp = "5492995343092"; 
  const mensajeDefault = "¡Hola! Vengo de la página web de Páscolo y quiero hacer un pedido.";
  const linkWhatsapp = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensajeDefault)}`;

  const closeMobileMenu = () => setIsOpen(false);

  return (
    <>
    <nav className="navbar">
      {/* 1. Izquierda (Solo Móvil): Menú Hamburguesa */}
      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '✖' : '☰'}
      </div>

      {/* 2. Centro (Móvil) / Izquierda (PC): Logo */}
      <div className="navbar-logo">
        <Link to="/" onClick={closeMobileMenu}>
          <img src={logoPascolo} alt="Pascolo" className="navbar-logo-img" />
        </Link>
      </div>
      
      {/* Links Desplegables */}
      <ul className={isOpen ? "navbar-links active" : "navbar-links"}>
        <li><Link to="/" onClick={closeMobileMenu}>Inicio</Link></li>
        <li><Link to="/productos" onClick={closeMobileMenu}>Productos</Link></li>
        <li><Link to="/quienes-somos" onClick={closeMobileMenu}>Quiénes Somos</Link></li>
        <li><Link to="/como-producimos" onClick={closeMobileMenu}>Cómo Producimos</Link></li>
      </ul>

      {/* 3. Derecha: Acciones (Carrito + WhatsApp) */}
        <div className="navbar-action" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          
          {/* --- NUEVO: Botón de Seguimiento con texto --- */}
          <Link 
            to="/pedidos" 
            onClick={closeMobileMenu}
            style={{ 
              color: 'white', 
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 'bold',
              border: '1px solid white',
              padding: '6px 12px',
              borderRadius: '20px',
              whiteSpace: 'nowrap'
            }}
          >
            Seguimiento de pedidos
          </Link>

          {/* --- NUEVO: Botón del Carrito --- */}
          <button 
            className="btn-abrir-carrito" 
            onClick={() => setIsCartOpen(!isCartOpen)}
            style={{ 
              background: 'none', border: 'none', cursor: 'pointer', 
              position: 'relative', padding: '2px 3px', fontSize: '22px', color: 'white',
              display: 'flex', alignItems: 'center'
            }}
          >
            <FaShoppingCart />
            {totalItems > 0 && (
              <span className="carrito-badge" style={{
                position: 'absolute', top: '-8px', right: '-12px', 
                background: '#d9534f', color: 'white', fontSize: '11px', 
                padding: '2px 6px', borderRadius: '50%'
              }}>
                {totalItems}
              </span>
            )}
          </button>

        </div>
      </nav>

      {/* RENDERIZAMOS EL MODAL: 
          Lo ponemos fuera de la etiqueta <nav> para que su posición fixed 
          no se rompa con los estilos de la barra de navegación */}
      <CarritoSidebar isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
};

export default Navbar;